import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import {
  MenuItem,
  withStyles,
} from '@material-ui/core'
import {
  Add as AddIcon,
  Refresh as RefreshIcon,
} from '@material-ui/icons'

import { getClients, addClient } from '../actions/client'
import Select from '../components/Select'
import Button from '../components/Button'
import Modal from '../components/Modal'
import InputText from '../components/InputText'


const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
  },
  select: {
    flex: 1,
  },
  spacing: {
    marginLeft: theme.spacing(1),
  },
  spacingTop: {
    marginTop: theme.spacing(1),
  },
})


class SelectClient extends Component {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of the Component
   */
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      modalOpened: false,
    }

    this.input = createRef()
  }

  /**
   * @componentWillMount
   */
  componentWillMount() {
    const { clients } = this.props

    if (!clients.length) {
      this.props.getClients()
    }
  }

  componentDidUpdate(_, prevState) {
    const { modalOpened } = prevState

    if (!modalOpened && this.state.modalOpened) {
      this.focusInput()
    }
  }


  /* METHODS */

  focusInput = () => {
    const { current: input } = this.input

    if (input) {
      input.focus()
    }
  }

  handleRefresh = () => this.props.getClients()

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleOpenModal = () => this.setState({ modalOpened: true })

  handleCloseModal = () => {
    if (this.props.isLoading) {
      return null
    }

    return this.setState({
      name: '',
      modalOpened: false,
    })
  }

  handleCreateClient = async () => {
    const validated = await this.props.addClient({
      name: this.state.name,
    })

    if (validated) {
      this.handleCloseModal()
      this.handleRefresh()
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      clients,
      withAdd,
      isLoading,
      className,
      withRefresh,
      ...rest
    } = this.props
    const {
      name,
      modalOpened,
    } = this.state

    return (
      <div className={classNames(classes.root, className)}>
        <Select
          fullWidth
          className={classes.select}
          label="Sélectionner un client"
          {...rest}
        >
          {clients.map(client => (
            <MenuItem
              value={client.id}
              key={`select-${client.id}`}
            >
              {client.name}
            </MenuItem>
          ))}
        </Select>

        {withRefresh && <Button isLoading={isLoading} className={classes.spacing}><RefreshIcon /></Button>}
        {withAdd && <Button isLoading={isLoading} color="primary" className={classes.spacing} onClick={this.handleOpenModal}><AddIcon />&nbsp;Créer un client</Button>}

        <Modal
          keepMounted
          open={modalOpened}
          submitLabel="Créer"
          cancelLabel="Annuler"
          isLoading={isLoading}
          title="Créer un client"
          onClose={this.handleCloseModal}
          onCancel={this.handleCloseModal}
          onSubmit={this.handleCreateClient}
        >
          <InputText
            fullWidth
            name="name"
            label="Nom"
            value={name}
            ref={this.input}
            onChange={this.handleChange}
            className={classes.spacingTop}
            onPressEnter={this.handleCreateClient}
          />
        </Modal>
      </div>
    )
  }
}


SelectClient.defaultProps = {
  clients: [],
}


SelectClient.propTypes = {
  withAdd: PropTypes.bool,
  isLoading: PropTypes.bool,
  withRefresh: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  addClient: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(PropTypes.object),
}


const mapStateToProps = state => ({
  clients: state.list.clients,
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  addClient,
  getClients,
})(withStyles(styles)(SelectClient))
